
import PopupLead from './components/PopupLead.vue'
import ConfirmPopupLead from "./components/ConfirmPopupLead";

export default {
    el: '#popup_lead',
    components: { PopupLead, ConfirmPopupLead },
    template: '<div><PopupLead/><ConfirmPopupLead id="confirm-popup-lead"/></div>',
};
